import { For, Show } from "solid-js";
import { AmountPill } from "./amount_pill";
import { useDenominationsGridV2Context } from "../context/denominations_grid_v2_context";

export function AmountSelector() {
  const gridState = useDenominationsGridV2Context();
  const { denominationList, internalState, setCustomSelected } = gridState;
  const { selectedAmount, setSelectedAmount } = internalState;

  // Determine columns: 2 if 4 or fewer items, 3 if more than 4
  const columnsCount = () => (denominationList.length <= 4 ? 2 : 3);

  // Split denominations into rows based on column count
  const getRows = () => {
    const cols = columnsCount();
    const rows: number[][] = [];
    for (let i = 0; i < denominationList.length; i += cols) {
      rows.push(denominationList.slice(i, i + cols));
    }
    return rows;
  };

  return (
    <div class="flex w-full flex-col gap-3">
      <For each={getRows()}>
        {(row) => (
          <div class="flex w-full gap-3">
            <For each={row}>
              {(amount) => (
                <AmountPill
                  amount={`₹${amount.toLocaleString()}`}
                  isSelected={selectedAmount() === amount}
                  onClick={() => {
                    setCustomSelected(false);
                    setSelectedAmount(amount);
                  }}
                  class="flex-1"
                />
              )}
            </For>
            {/* Add empty spacers if row has fewer items than columns */}
            <Show when={row.length < columnsCount()}>
              <For each={Array(columnsCount() - row.length)}>
                {() => <div class="flex-1" />}
              </For>
            </Show>
          </div>
        )}
      </For>
    </div>
  );
}
